import React from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';

interface ValidationError {
	customerIndex: number;
	clientId?: string;
	errors: Array<{ field: string; message: string }>;
}

interface ValidationErrorsListProps {
	errors: ValidationError[];
	t: (key: string) => string;
}

const ValidationErrorsList: React.FC<ValidationErrorsListProps> = ({ errors, t }) => {
	if (errors.length === 0) return null;

	return (
		<div className="mb-4 p-4 bg-red-50 border border-red-200 rounded">
			<div className="text-red-800 mb-2">
				<Typography size="md" weight="medium">
					{t('ValidationErrors')}
				</Typography>
			</div>
			<div className="space-y-2 max-h-60 overflow-y-auto custom-scrollbar">
				{errors.map((error, idx) => (
					<div key={idx} className="text-sm text-red-700">
						<strong>
							{t('Customer')} {error.customerIndex + 1}
							{error.clientId && ` (${error.clientId})`}:
						</strong>
						<ul className="ml-4 list-disc">
							{error.errors.map((err, errIdx) => (
								<li key={errIdx}>
									{err.field}: {err.message}
								</li>
							))}
						</ul>
					</div>
				))}
			</div>
		</div>
	);
};

export default ValidationErrorsList;
